/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ExamCorrectExamMutationRequest,
  PostApiV1ExamCorrectExamMutationResponse,
  PostApiV1ExamCorrectExam400,
  PostApiV1ExamCorrectExam401,
  PostApiV1ExamCorrectExam500,
} from "../../types/examCorrectionDashboardController/PostApiV1ExamCorrectExam.ts";

function getPostApiV1ExamCorrectExamUrl() {
  const res = { method: "POST", url: `/api/v1/exam/correct-exam` as const };
  return res;
}

/**
 * @description Salva a correção de texto para uma resposta específica da prova enviada pelo usuário. **(Requer Authorization para autenticação)**
 * @summary Enviar correção da prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/correct-exam}
 */
export async function postApiV1ExamCorrectExam(
  data: PostApiV1ExamCorrectExamMutationRequest,
  config: Partial<RequestConfig<PostApiV1ExamCorrectExamMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1ExamCorrectExamMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamCorrectExam400
      | PostApiV1ExamCorrectExam401
      | PostApiV1ExamCorrectExam500
    >,
    PostApiV1ExamCorrectExamMutationRequest
  >({
    method: "POST",
    url: getPostApiV1ExamCorrectExamUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
